import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CsProjectsComponent } from './cs-projects/cs-projects.component';
import { AuthGuard } from './auth/auth-guard';
import { CsBuildupComponent } from './cs-buildup/cs-buildup.component';
import { HomeComponent } from './home/home.component';
import { ImpressumComponent } from './impressum/impressum.component';
import { PendingChangesGuard } from './shared';


const routes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'projects', component: CsProjectsComponent, canActivate: [ AuthGuard ]},
  {path: 'projects/:id', component: CsBuildupComponent, canActivate: [ AuthGuard ], canDeactivate: [ PendingChangesGuard ]},
  {path: 'impressum', component: ImpressumComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
